import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.password.required)
      .min(8, VALIDATION_MESSAGES.password.min)
      .max(20, VALIDATION_MESSAGES.password.max)
      .refine((val) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,20}$/.test(val), {
        message: VALIDATION_MESSAGES.password.strength,
      }),
    confirmPassword: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.confirmPassword.required)
      .min(8, VALIDATION_MESSAGES.confirmPassword.min)
      .max(20, VALIDATION_MESSAGES.confirmPassword.max),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: VALIDATION_MESSAGES.confirmPassword.match,
    path: ['confirmPassword'],
  });

export type TResetPassword = z.infer<typeof resetPasswordSchema>;
